import React, { useState, useEffect, useMemo } from 'react'
import { loadStripe } from "@stripe/stripe-js";
import {
    CardElement,
    Elements,
    useElements,
    useStripe,
} from "@stripe/react-stripe-js";
import AddDeliveryAddress from '../../composed/deliveryaddress/AddDeliveryAddress';
import PageBase from '../../composed/pagebase/pagebase';
import './css/CustomerAccountDesktop.scss';
import CustomerAccountTabs from '../../atomic/CustomerAccountTabs/CustomerAccountTabs';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import { getUrlParams, getUrlPath, getUrlFullPath, removeParamFromUrl } from "../../global/getUrl";
import YourPaymentMethod from '../../composed/yourpaymentmethod/YourPaymentMethod';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);


// tab names should also be in generateTabNames return 
const customerAcctTabNames = ['account', 'your orders', 'your addresses', 'your payments', 'subscription']



const generateTabNames = (getUrlPath) => {
    // You have to create paths on app.js before coming here to add tan name
    switch (getUrlPath) {
        case '/customeraccount':
            return ('account');
        case '/customeraccount/deliveryaddress':
            return ('your addresses');
        case '/customeraccount/orders':
            return ('your orders');
        case '/customeraccount/cards':
            return ('your payments');
        case '/customeraccount/subscription':
            return ('subscription');
    }
}




const CustomerAccountDesktop = () => {

    const [tabValue, setTabValue] = useState(generateTabNames(getUrlPath()))


    const renderComponents = (tabName) => {
        switch (tabName) {
            case 'account':
                return <div> Account Component</div>
            case 'your orders':
                return <div> Your Orders component</div>;
            case 'your addresses':
                return <AddDeliveryAddress />;
            case 'your payments':
                return <div>
                    <Elements stripe={stripePromise}>
                        <YourPaymentMethod />
                    </Elements>
                </div>;
            case 'subscription':
                return <div> Your subscription component</div>;


        }
    }

    if (isIpad) {
        return (
            <div className='cust-acct-container-ipad'>

                <div className='section-1'>
                    <CustomerAccountTabs customerAcctTabNames={customerAcctTabNames} tabValue={tabValue} setTabValue={setTabValue} />
                </div>

                <div className='section-2'>
                    {renderComponents(tabValue)}
                </div>
            </div>

        )


    }



    return (
        <PageBase>

            <div className='cust-acct-container-desktop'>

                <div className='section-1'>
                    <CustomerAccountTabs customerAcctTabNames={customerAcctTabNames} tabValue={tabValue} setTabValue={setTabValue} />
                </div>

                <div className='section-2'>
                    {renderComponents(tabValue)}
                </div>


            </div>
        </PageBase>
    )
}

export default CustomerAccountDesktop